export default {
  async updateUserInfo(ctx) {
    const action = await ibb.getUserInfo();
    if (action.error.type) {
      ctx.commit('setUserInfo', {});
      throw new Error('Error getting user info: ' + action.error.type);
    }
    ctx.commit('setUserInfo', action.userInfo);
    return ctx.state.userInfo;
  },
  async updateAccountInfo(ctx) {
    const action = await ibb.getAccountInfo();
    if (action.error.type) {
      ctx.commit('setAccountInfo', {});
      throw new Error('Error getting account info: ' + action.error.type);
    }
    action.accountInfo.email = action.email;
    action.accountInfo.link = action.link;
    ctx.commit('setAccountInfo', action.accountInfo);
    return ctx.state.accountInfo;
  },
  async updateInvoicingInfo(ctx) {
    const action = await ibb.getInvoicingInfo();
    if (action.error.type) {
      ctx.commit('setInvoicingInfo', {});
      throw new Error('Error getting invoicing info: ' + action.error.type);
    }
    ctx.commit('setInvoicingInfo', action.invoicingInfo);
    return ctx.state.invoicingInfo;
  }
};
